"use strict";module.exports=function(argument){return"string"==typeof argument||"symbol"==typeof argument};